export default "__VITE_ASSET__9630fbb4__"